var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background-color":"lightgrey","width":"100%"}},[_c('md-card',[_c('h2',{staticClass:"text-center"},[_c('b',[_vm._v(_vm._s(_vm.message))])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }